import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../permission.service';

@Directive({
    selector: '[hasAllPermission]',
    standalone: false
})
export class PermissionAllDirective {
  constructor(
    private permissionService: PermissionService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set hasAllPermission(permissions: string[]) {
    if (this.permissionService.hasAllPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
